import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import StocksReportsScreen from "../../../screens/Reports/StocksReportScreens/StocksReportScreen";
import PrdouctsReportsScreen from "../../../screens/Reports/ProductsReportScreens/ProductsReportScreen";
import CustomerStatusReportsScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusReportScreen";
import { drawerItemsMain } from "./ReportsDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import DynamicWidthScreen from "../../../screens/NotUsed/DynamicWidthScreen";
import StockReportDetailsReportScreen from "../../../screens/Reports/StocksReportScreens/StockReportDetailsReport";
import CustomerStatusDetailReportScreen from "../../../screens/Reports/CustomerStatusReportScreens/CustomerStatusDetailReportScreen";
import { useTranslation } from "../../../utils/useTranslation";
const Drawer = createDrawerNavigator();

export default function ReportsDrawerNavigator() {
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  return (
    <Drawer.Navigator
      initialRouteName="Home"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={drawerItemsMain} {...props} />
      )}
    >
      <Drawer.Screen
        name="Stocks"
        component={StocksReportsScreen}
        options={{ title: t("stock") }}
      />
      <Drawer.Screen
        name="Products"
        component={PrdouctsReportsScreen}
        options={{ title: t("searchProduct") }}
      />
      <Drawer.Screen
        name="CustomerStatus"
        component={CustomerStatusReportsScreen}
        options={{ title: t("customerStatus") }}
      />
      <Drawer.Screen
        name="CustomerStatusDetailReportScreen"
        component={CustomerStatusDetailReportScreen}
        options={{ title: t("customerStatusDetails") }}
      />
      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          name="DynamicWidth"
          component={DynamicWidthScreen}
          options={{ title: t("dynamicWidthScreen") }}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: "StockReportDetailsReportScreen",
          title: t("stockReportDetails"),
        }}
        name="StockReportDetailsReportScreen"
        component={StockReportDetailsReportScreen}
      />
    </Drawer.Navigator>
  );
}
